import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add, Receipt, Visibility, RestoreFromTrash, Apps, Settings } from '@material-ui/icons';
import { Tooltip } from '@material-ui/core';

//tabla y card components
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import { Link } from 'react-router-dom';
import { wsUpdate } from 'services/WService';
import RegularButton from 'components/CustomButtons/Button';
import UserAppModal from 'components/Tvendo/Setting/User/UserAppModal';
import UserAppSettingsModal from 'components/Tvendo/Setting/User/UserAppSettingsModal';
import ButtonResetPassword from 'components/Tvendo/Common/ButtonResetPassword';
import Badge from 'components/Badge/Badge';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 290 },
  { Header: 'Código', accessor: 'code', width: 100 },
  { Header: 'Nombre vendedor', accessor: 'name', width: 200 },
  { Header: 'Fecha de creación', accessor: 'created_at', width: 170 },
  { Header: 'DNI', accessor: 'dni', width: 150 },
  { Header: 'Teléfono', accessor: 'phone', width: 150 },
  { Header: 'Múltiple FV', accessor: 'multiple_sale_forces', width: 115, excelEnabled: false },
  { Header: 'Múltiple FV', accessor: 'multiple_sale_forces_texto', hidden: true },
  { Header: 'Tipo', accessor: 'seller_type', width: 150 },
  { Header: 'Validar gps', accessor: 'validate_gps', width: 115, excelEnabled: false },
  { Header: 'Validar gps', accessor: 'validate_gps_texto', hidden: true },
  { Header: 'Mesas', accessor: 'mesas', width: 250 },
  { Header: 'Exigir Ult. Ver.', accessor: 'validate_version', width: 110, excelEnabled: false },
  { Header: 'Exigir Ult. Ver.', accessor: 'validate_version_texto', hidden: true },
  { Header: 'Restr. GPS Falso', accessor: 'false_gps', width: 110, excelEnabled: false },
  { Header: 'Restr. GPS Falso', accessor: 'false_gps_texto', hidden: true },
  { Header: 'Valid. Distancia', accessor: 'validate_distace', width: 110, excelEnabled: false },
  { Header: 'Valid. Distancia', accessor: 'validate_distace_texto', hidden: true },
  { Header: 'GPS Preciso', accessor: 'optimized_gps', width: 100, excelEnabled: false },
  { Header: 'GPS Preciso', accessor: 'optimized_gps_texto', hidden: true },
  { Header: 'Dist. Foto Mueble', accessor: 'validate_furniture_distance', width: 120, excelEnabled: false },
  { Header: 'Dist. Foto Mueble', accessor: 'validate_furniture_distance_texto', hidden: true },
  { Header: 'Corregir Foto Mueble', accessor: 'edit_furniture_photo', width: 130, excelEnabled: false },
  { Header: 'Corregir Foto Mueble', accessor: 'edit_furniture_photo_texto', hidden: true },
  { Header: 'Dig. Fuera Ruta', accessor: 'remote_order_auth', width: 110, excelEnabled: false },
  { Header: 'Dig. Fuera Ruta', accessor: 'remote_order_auth_texto', hidden: true },
  { Header: 'Cerrar Antes Hora', accessor: 'early_close_auth', width: 120, excelEnabled: false },
  { Header: 'Cerrar Antes Hora', accessor: 'early_close_auth_texto', hidden: true },
  // { Header: 'Fabricante', accessor: 'rsales_manufacturer', width: 150 },
  // { Header: 'Modelo', accessor: 'rsales_model', width: 150 },
  // { Header: 'UUID', accessor: 'rsales_uuid', width: 150 },
  { Header: 'Estado', accessor: 'state', width: 150 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Seller(props) {
  const classes = useStyles();
  const totalTableWidth = columns.reduce((sum, col) => sum + (col.width || 0), 0);

  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [sellers, setSellers] = useState([]);
  const [appModel, setAppModel] = useModal();
  const [settingsModel, setSettingsModel] = useModal();

  const [trashed, setTrashed] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  async function loadSellers() {
    setDataLoading(true);
    let response = await wsGetAll(`base/seller${trashed ? '?trashed=Y' : ''}`);
    setDataLoading(false);
    if (response.success) setSellers(response.data);
  }

  async function restoreSeller(seller) {
    setDataLoading(true);
    let response = await wsUpdate(`base/seller/${seller.id}/restore`);
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      loadSellers();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    setSellers([]);
    loadSellers();
  }, [trashed]);

  return (
    <>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={loadSellers} />
      <UserAppModal
        model={appModel}
        setOpen={setAppModel}
        showNotify={showNotify}
        canDelete={false}
        reload={loadSellers}
        showSettings={false}
      />
      <UserAppSettingsModal
        model={settingsModel}
        setOpen={(m) => {
          setSettingsModel(m);
          // al cerrar se recarga para que las columnas de permisos muestren lo que se cambió
          if (m?.open === false) loadSellers();
        }}
        showNotify={showNotify}
      />
      <Card>
        <CardHeader icon>
          <AllowedGuard
            permission={ConstantPermissions.BASE_SELLERS_STORE}
            component={
              <CardIcon color="primary">
                <Receipt style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <CardIcon
              onClick={() => setOpen({})}
              pointer="true"
              color={props.themeContext.buttonColorSuccess}
            >
              <Add />
            </CardIcon>
          </AllowedGuard>
          <h4 className={classes.cardIconTitle}>
            Listado de Vendedores {dataLoading && <LoadingSpinner />}
          </h4>

          <button onClick={() => setTrashed((trashed) => !trashed)}>
            {trashed ? 'Ver activos' : 'Ver eliminados'}
          </button>
        </CardHeader>
        <CardBody>
          <ReactTable
            excelName="Vendedores"
            defaultWidth={totalTableWidth}
            columns={columns}
            data={sellers.map((seller, i) => {
              //mapeando listado para las acciones
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    {seller.deleted_at === null ? (
                      <>
                        <AllowedGuard permission={ConstantPermissions.BASE_SELLERS_UPDATE}>
                          <Button
                            justIcon
                            round
                            simple
                            color={props.themeContext.buttonColorWarning}
                            onClick={() => setOpen(seller)}
                          >
                            <Create />
                          </Button>
                        </AllowedGuard>
                        <AllowedGuard permission={ConstantPermissions.BASE_SELLERS_SHOW}>
                          <Button
                            justIcon
                            round
                            simple
                            color={props.themeContext.buttonColorWarning}
                            disabled={seller.seller_type === 'O'}
                          >
                            <Link to={`${seller.id}`}>
                              <Visibility />
                            </Link>
                          </Button>
                        </AllowedGuard>
                        <AllowedGuard permission={ConstantPermissions.BASE_SELLERS_UPDATE}>
                          <RegularButton
                            justIcon
                            round
                            simple
                            color="info"
                            onClick={() => setAppModel(seller.user)}
                            disabled={seller.user === null || seller.user === undefined}
                          >
                            <Apps />
                          </RegularButton>
                        </AllowedGuard>
                        <AllowedGuard permission={ConstantPermissions.BASE_SELLERS_UPDATE}>
                          <Tooltip title="Configuración y permisos">
                            <span>
                              <RegularButton
                                justIcon
                                round
                                simple
                                color="info"
                                onClick={() => setSettingsModel({ userId: seller.user.id, userName: seller.SlpName })}
                                disabled={seller.user === null || seller.user === undefined}
                              >
                                <Settings />
                              </RegularButton>
                            </span>
                          </Tooltip>
                        </AllowedGuard>
                        <AllowedGuard permission={ConstantPermissions.ADMIN_ACCESS_USER_CHANGE_PASSWORD}>
                          <ButtonResetPassword
                            userId={seller.user?.id}
                            nombre={seller.SlpName}
                          />
                        </AllowedGuard>
                        <AllowedGuard permission={ConstantPermissions.BASE_SELLERS_DELETED}>
                          <ButtonDelete entity="base/seller" id={seller.id} reload={loadSellers} />
                        </AllowedGuard>
                      </>
                    ) : (
                      <>
                        <AllowedGuard permission={ConstantPermissions.BASE_SELLERS_DELETED}>
                          <Button
                            justIcon
                            round
                            simple
                            onClick={() => restoreSeller(seller)}
                            color="success"
                          >
                            <RestoreFromTrash />
                          </Button>
                        </AllowedGuard>
                      </>
                    )}
                  </div>
                ),
                code: seller.SlpCode,
                name: seller.SlpName,
                created_at: seller.created_at,
                dni: seller.dni,
                phone: seller.phone,
                multiple_sale_forces: (
                  <Badge color={seller.multiple_sale_forces === 'Y' ? 'success' : 'warning'}>
                    {seller.multiple_sale_forces === 'Y' ? 'Si' : 'No'}
                  </Badge>
                ),
                multiple_sale_forces_texto: seller.multiple_sale_forces === 'Y' ? 'Si' : 'No',
                seller_type:
                  seller.seller_type === 'S' ? 'Campo' : seller.seller_type ? 'Oficina' : '-',
                validate_gps: (
                  <Badge color={seller.validate_gps === 'Y' ? 'success' : 'warning'}>
                    {seller.validate_gps === 'Y' ? 'Si' : 'No'}
                  </Badge>
                ),
                validate_gps_texto: seller.validate_gps === 'Y' ? 'Si' : 'No',
                mesas: seller.mesas ?? '-',
                validate_version: (
                  <Badge color={seller.oauth_app_user?.validate_version === '1' ? 'success' : 'warning'}>
                    {seller.oauth_app_user?.validate_version === '1' ? 'Si' : 'No'}
                  </Badge>
                ),
                validate_version_texto: seller.oauth_app_user?.validate_version === '1' ? 'Si' : 'No',
                false_gps: (
                  <Badge color={seller.oauth_app_user?.false_gps === '1' ? 'success' : 'warning'}>
                    {seller.oauth_app_user?.false_gps === '1' ? 'Si' : 'No'}
                  </Badge>
                ),
                false_gps_texto: seller.oauth_app_user?.false_gps === '1' ? 'Si' : 'No',
                validate_distace: (
                  <Badge color={seller.oauth_app_user?.validate_distace === '1' ? 'success' : 'warning'}>
                    {seller.oauth_app_user?.validate_distace === '1' ? 'Si' : 'No'}
                  </Badge>
                ),
                validate_distace_texto: seller.oauth_app_user?.validate_distace === '1' ? 'Si' : 'No',
                optimized_gps: (
                  <Badge color={seller.oauth_app_user?.optimized_gps === '1' ? 'success' : 'warning'}>
                    {seller.oauth_app_user?.optimized_gps === '1' ? 'Si' : 'No'}
                  </Badge>
                ),
                optimized_gps_texto: seller.oauth_app_user?.optimized_gps === '1' ? 'Si' : 'No',
                validate_furniture_distance: (
                  <Badge color={seller.oauth_app_user?.validate_furniture_distance === '1' ? 'success' : 'warning'}>
                    {seller.oauth_app_user?.validate_furniture_distance === '1' ? 'Si' : 'No'}
                  </Badge>
                ),
                validate_furniture_distance_texto:
                  seller.oauth_app_user?.validate_furniture_distance === '1' ? 'Si' : 'No',
                edit_furniture_photo: (
                  <Badge color={seller.oauth_app_user?.edit_furniture_photo === '1' ? 'success' : 'warning'}>
                    {seller.oauth_app_user?.edit_furniture_photo === '1' ? 'Si' : 'No'}
                  </Badge>
                ),
                edit_furniture_photo_texto: seller.oauth_app_user?.edit_furniture_photo === '1' ? 'Si' : 'No',
                remote_order_auth: (
                  <Badge color={seller.oauth_app_user?.remote_order_auth === '1' ? 'success' : 'warning'}>
                    {seller.oauth_app_user?.remote_order_auth === '1' ? 'Si' : 'No'}
                  </Badge>
                ),
                remote_order_auth_texto: seller.oauth_app_user?.remote_order_auth === '1' ? 'Si' : 'No',
                early_close_auth: (
                  <Badge color={seller.oauth_app_user?.early_close_auth === '1' ? 'success' : 'warning'}>
                    {seller.oauth_app_user?.early_close_auth === '1' ? 'Si' : 'No'}
                  </Badge>
                ),
                early_close_auth_texto: seller.oauth_app_user?.early_close_auth === '1' ? 'Si' : 'No',
                rsales_manufacturer: seller.oauth_app_user?.rsales_manufacturer ?? '-',
                rsales_model: seller.oauth_app_user?.rsales_model ?? '-',
                rsales_uuid: seller.oauth_app_user?.rsales_uuid ?? '-',
                state: seller.state === 'A' ? 'Activo' : 'Inactivo',
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
